import { Controller } from "@hotwired/stimulus"

/**
 * Controls the domain name form, toggling field visibility based on domain_type.
 *
 * When domain_type is "primary":
 *   - Shows: active_subdomain, inactive_action (for subdomain handling)
 *   - Hides: redirect_url, subdomain_redirects
 *
 * When domain_type is "redirect":
 *   - Shows: redirect_url, inactive_action (for redirect type), subdomain_redirects
 *   - Hides: active_subdomain
 *
 * Both types show: name, skip_subdomains
 */
export default class extends Controller {
  static targets = ["primaryField", "redirectField"]

  connect() {
    this.updateDisplay()
  }

  updateDisplay() {
    const select = this.element.querySelector('select[name*="domain_type"]')
    if (!select) return

    const isPrimary = select.value === "primary"

    // Show/hide primary-only fields (active_subdomain)
    this.primaryFieldTargets.forEach(field => {
      if (isPrimary) {
        field.classList.remove("hidden")
      } else {
        field.classList.add("hidden")
      }
    })

    // Show/hide redirect-only fields (redirect_url, subdomain_redirects)
    this.redirectFieldTargets.forEach(field => {
      if (isPrimary) {
        field.classList.add("hidden")
      } else {
        field.classList.remove("hidden")
      }
    })

    // Update the inactive_action label based on domain type
    this.updateInactiveActionLabel(isPrimary)
  }

  updateInactiveActionLabel(isPrimary) {
    const label = this.element.querySelector('label[for="domain_name_inactive_action"]')
    if (!label) return

    if (isPrimary) {
      label.textContent = "Inactive Subdomain Action"
    } else {
      label.textContent = "Redirect Type"
    }

    // Update the help text as well
    const helpText = label.closest('.space-y-6, div')?.querySelector('p.text-xs.text-gray-500')
    if (helpText && helpText.previousElementSibling?.id === 'domain_name_inactive_action') {
      if (isPrimary) {
        helpText.textContent = "What to do with inactive subdomains"
      } else {
        helpText.textContent = "Use 301 for permanent redirects (SEO recommended), 302 for temporary"
      }
    }
  }
}
